$mol_lights_toggle $mol_check_icon
	Icon <= Lights_icon $mol_icon_brightness_6
	hint @ \Toggle lights
	checked? <=> lights? false
